"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var DummyWindow_1 = require("./DummyWindow");

var DummyWindowInfoDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DummyWindowInfoDTO, _DomainObject_1$Domai);

  function DummyWindowInfoDTO(isUsed, dummyWindow) {
    var _this;

    _classCallCheck(this, DummyWindowInfoDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowInfoDTO).call(this));
    _this.isUsed = isUsed;
    _this.dummyWindow = dummyWindow;
    return _this;
  }

  return DummyWindowInfoDTO;
}(DomainObject_1.DomainObject);

exports.DummyWindowInfoDTO = DummyWindowInfoDTO;

DummyWindowInfoDTO.schema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(DummyWindowInfoDTO.name);
  return {
    isUsed: bld.bool('isUsed'),
    dummyWindow: bld.obj(DummyWindow_1.DummyWindow.name, DummyWindow_1.DummyWindow.schema, function (mat) {
      return new DummyWindow_1.DummyWindow(mat.id, mat.windowName, mat.articleName, mat.productId);
    })
  };
}();